export default __webpack_public_path__ + "static/media/container_bg.87a29157.png";